import fetcher from 'features/shared/utils/fetcher'

async function getSelectOptions(country: any) {
  
  return await fetcher.get('/select-options/' + country)
}

export default getSelectOptions
